module.exports = __webpack_public_path__ + "static/media/logo_sm.ccd71342.png";